<template>
  <div
    class="mx-4 min-h-[48px] rounded-2xl shadow-lg backdrop-blur-sm px-4 py-3 flex items-center gap-3"
    :class="[colors[color]]"
  >
    <component :is="icons[color]" class="h-6 w-6 shrink-0" />
    <span class="flex-1 text-[14px] font-semibold">
      <slot />
    </span>
    <button
      class="shrink-0 rounded-full p-1 transition-colors hover:bg-white/20 active:bg-white/30"
      @click="emits('end')"
    >
      <XMarkIcon class="h-5 w-5" />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, type Component } from 'vue'
import {
  XMarkIcon,
  ExclamationTriangleIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
} from '@heroicons/vue/24/outline'
import { SnackBarColors } from '../utils/Snackbar'

const props = withDefaults(defineProps<{
  color?: SnackBarColors
  duration?: number
}>(), {
  color: 'default',
  duration: 3000,
})

const emits = defineEmits<{
  (e: 'end'): void
}>()

const handleEndSnack = () => {
  emits('end')
}

const colors: Record<SnackBarColors, string> = {
  default: 'bg-gray-800/90 text-white',
  primary: 'bg-[#06C8FF]/90 text-white',
  secondary: 'bg-gray-500/90 text-white',
  error: 'bg-red-500/90 text-white',
  danger: 'bg-red-500/90 text-white',
  success: 'bg-emerald-500/90 text-white',
  warning: 'bg-amber-500/90 text-white',
}

const icons: Record<SnackBarColors, Component> = {
  default: InformationCircleIcon,
  primary: InformationCircleIcon,
  secondary: InformationCircleIcon,
  error: ExclamationTriangleIcon,
  danger: ExclamationTriangleIcon,
  success: CheckCircleIcon,
  warning: ExclamationCircleIcon,
}

onMounted(() => {
  setTimeout(() => {
    handleEndSnack()
  }, props.duration)
})
</script>
